import React from "react";
import { ShimmerDiv, ShimmerTitle } from "./ThemedShimmer";

const ArticleDetailSkeleton = ({ className = "" }) => (
  <div
    className={className}
    role="status"
    aria-busy="true"
    aria-label="Loading article"
  >
    <span className="skeleton-screen-reader-only">Loading article</span>
    <ShimmerTitle line={1} gap={10} />
    <div className="d-flex flex-column flex-lg-row gap-3 mt-3">
      <ShimmerDiv height={320} width="100%" rounded={8} />
      <ShimmerDiv height={320} width="100%" rounded={8} />
    </div>
    <ShimmerDiv className="mt-3" height={24} width="85%" rounded={4} />
    <ShimmerDiv className="mt-2" height={24} width="70%" rounded={4} />
    <ShimmerDiv className="mt-2" height={24} width="60%" rounded={4} />
  </div>
);

export default ArticleDetailSkeleton;
